import { render } from "./EditTemplate.vue?vue&type=template&id=5f920f14&scoped=true"
import script from "./EditTemplate.vue?vue&type=script&lang=js"
export * from "./EditTemplate.vue?vue&type=script&lang=js"

import "./EditTemplate.vue?vue&type=style&index=0&id=5f920f14&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f920f14"]])

export default __exports__